import { Trans } from '@lingui/react/macro';
import { Modal } from 'antd';
import { DateTime } from 'luxon';
import { useCallback, useMemo } from 'react';
import { useLocalStorage } from 'react-use';

const SERVICE_DATE = DateTime.fromISO('2025-10-14T01:00:00.000+03:00');

export function ServiceNotification() {
  const [isHidden, setIsHidden] = useLocalStorage(
    `service-notification-${SERVICE_DATE.toMillis().toString(36)}`,
    false
  );

  const isExpired = useMemo(() => SERVICE_DATE < DateTime.now(), []);

  const hide = useCallback(() => setIsHidden(true), [setIsHidden]);

  return (
    <Modal
      title={<Trans>Уведомление о проведении сервисных работ</Trans>}
      visible={!isHidden && !isExpired}
      cancelButtonProps={{ hidden: true }}
      onOk={hide}
    >
      <Trans>
        С 22:00 13 октября (МСК) по 01:00 14 октября (МСК), на коммуникационном
        оборудовании запланированы профилактические работы. В это время может
        наблюдаться недоступность системы GSM мониторинга и/или задержки в
        получении данных телеметрии от водоматов. Суммарное время перерыва
        составит не более 30 минут. Приносим извинения за доставленные
        неудобства.
      </Trans>
    </Modal>
  );
}
